export const UPDATE_COMPANY = "UPDATE_COMPANY";
// export const UPDATE_ORDER='Update order'
